// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","LoadingPlaceholderParent":"bcn_a bht_wl","LoadingPlaceholder":"bcn_b bht_h","loading-placeholder":"bcn_c"};